import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';

//Payload properties
var FORM_ID = "formId";
var FORM_TRIGGER_TYPE = "formTriggerType";
var FEEDBACK_UUID = "feedbackUUID";
var FEEDBACK_CORRELATION_UUID = "feedbackCorrelationUUID";
var FEEDBACK_CONTENT = "content";
var IS_PASSED = "isPassed";
var TARGETING_RULE = "targetingRule";
var EXPECTED = "expected";
var ACTUAL = "actual";
var FORM_LANGUAGE = "formLanguage";
var DIGITAL_UNIT_ID = 'digitalUnitId';


var getCustomEvents = function () {
  var customEvents = {
    MDigital_Form_Close_Submitted: {
      customEventId: "MDigital_Form_Close_Submitted",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_formReady: {
      customEventId: "MDigital_Form_Displayed",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_pageView: {
      customEventId: "MDigital_Page_View",
      payload: [],
    },
    MDigital_Form_Next_Page: {
      customEventId: "MDigital_Form_Next_Page",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    MDigital_Form_Back_Page: {
      customEventId: "MDigital_Form_Back_Page",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    MDigital_Form_Close_No_Submit: {
      customEventId: "MDigital_Form_Close_No_Submit",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    MDigital_ThankYou_Displayed: {
      customEventId: "MDigital_ThankYou_Displayed",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    MDigital_ThankYou_Close: {
      customEventId: "MDigital_ThankYou_Close",
      payload: [FORM_ID, FORM_TRIGGER_TYPE, FEEDBACK_UUID],
    },
    neb_feedbackSubmitted: {
      customEventId: 'MDigital_Submit_Feedback',
      payload: [FORM_ID,FORM_TRIGGER_TYPE,DIGITAL_UNIT_ID,FEEDBACK_UUID]
          .concat(isExposeFormLanguageAllowed() ? FORM_LANGUAGE : [])
          .concat(KAMPYLE_FUNC.isContentPayloadEnabled() ? FEEDBACK_CONTENT : [])

    },
    neb_feedbackPostSubmitted: {
      customEventId: 'MDigital_Submit_Feedback',
      payload: [FORM_ID,FORM_TRIGGER_TYPE,DIGITAL_UNIT_ID,FEEDBACK_UUID]
          .concat(isExposeFormLanguageAllowed() ? FORM_LANGUAGE : [])
          .concat(KAMPYLE_FUNC.isContentPayloadEnabled() ? FEEDBACK_CONTENT : [])

    },
    neb_inviteAccepted: {
      customEventId: "MDigital_Invite_Accepted",
      payload: [FORM_ID],
    },
    neb_showInvitation: {
      customEventId: "MDigital_Invite_Displayed",
      payload: [FORM_ID],
    },
    neb_inviteDeclined: {
      customEventId: "MDigital_Invite_Declined",
      payload: [FORM_ID],
    },
    neb_skipInvitation: {
      customEventId: "MDigital_invite_Skipped",
      payload: [FORM_ID],
    },
    neb_buttonClicked: {
      customEventId: "MDigital_Feedback_Button_Clicked",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_captureInit: {
      customEventId: "MDigital_CaptureButton_Clicked",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_captureImageClicked: {
      customEventId: "MDigital_CaptureButton_Taken",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_initButton: {
      customEventId: "MDigital_Button_Displayed",
      payload: [FORM_ID],
    },
    MDigital_Capture_Cancelled: {
      customEventId: "MDigital_CaptureButton_Cancel",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    screenCaptureDelete: {
      customEventId: "MDigital_ScreenCapture_Delete",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    screenCaptureRetake: {
      customEventId: "MDigital_ScreenCapture_Retake",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    neb_sdkShowForm: {
      customEventId: "MDigital_ShowForm_Called",
      payload: [FORM_ID, FORM_TRIGGER_TYPE],
    },
    MDigital_targetingRuleEvaluated: {
      customEventId: "MDigital_targetingRuleEvaluated",
      payload: [
        FORM_ID,
        IS_PASSED,
        TARGETING_RULE,
        EXPECTED,
        ACTUAL,
        FORM_TRIGGER_TYPE,
      ],
    },
  };
  const submitEventKey = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DISABLE_EXTRA_FEEDBACK_SUBMIT_EVENT) ?
      'neb_feedbackSubmitted' : 'neb_submitFeedbackSuccess';

  customEvents[submitEventKey] = {
    customEventId: "MDigital_Submit_Feedback",
    payload: [FORM_ID, FORM_TRIGGER_TYPE, FEEDBACK_UUID]
        .concat(isExposeFormLanguageAllowed() ? FORM_LANGUAGE : [])
        .concat(KAMPYLE_FUNC.isContentPayloadEnabled() ? FEEDBACK_CONTENT : []),
  }
  return customEvents;
};

//Mapping of the payload property to the exposed property and the manipulate value method if exists
var dataToSendMapping = {
  formId: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FORM_ID_LABEL,
    manipulateValueMethod: null,
  },
  formTriggerType: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FORM_TYPE_LABEL,
    manipulateValueMethod: manipulateTriggerTypeValue,
  },
  feedbackCorrelationUUID: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FEEDBACK_UUID_LABEL,
  },
  feedbackUUID: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FEEDBACK_UUID_LABEL,
    manipulateValueMethod: null,
  },
  digitalUnitId: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.DIGITAL_UNIT_ID,
    manipulateValueMethod: null
  },
  content: {
    exposedProperty:
      KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FEEDBACK_CONTENT_LABEL,
    manipulateValueMethod: null,
  },
  formLanguage: {
    exposedProperty: KAMPYLE_CONSTANT.EXPOSED_FEEDBACK_KEYS.FORM_LANGUAGE_LABEL,
    manipulateValueMethod: null,
  },
};

function init() {
  if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DECIBEL_INSIGHT)) {
    // Inform DXA to disable their listeners
    window.dxa_digital_listener_disabled = true;
  }

  const customEvents = getCustomEvents();

  try {
    KAMPYLE_UTILS.initEventSubscriptions(customEvents, triggerCustomEvent);
    return true;
  } catch (e) {
    console.warn(e);
  }
}

function formatData(eventName, eventDispatcherData) {
  const customEvents = getCustomEvents();

  if (!eventName || !eventDispatcherData) {
    return null;
  }
  //Fill with event specific variables
  for (var eventProp in customEvents[eventName]) {
    if (customEvents[eventName].hasOwnProperty(eventProp)) {
      eventDispatcherData[eventProp] = customEvents[eventName][eventProp];
    }
  }
  eventDispatcherData.eventName = eventName;
  eventDispatcherData.formTriggerType = KAMPYLE_DATA.getFormTriggerType(
    eventDispatcherData.formId
  );
  return eventDispatcherData;
}

function triggerCustomEvent(eventName, eventDispatcherData) {
  var eventDispatcherDataFormatted = formatData(eventName, eventDispatcherData);
  var customEventData = getCustomEventDataToSend(eventDispatcherDataFormatted);
  if (customEventData) {
    var customEventId = eventDispatcherDataFormatted.customEventId;
    KAMPYLE_UTILS.triggerCustomEvent(customEventId, customEventData);
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DECIBEL_INSIGHT)) {
      triggerCustomCallback(customEventId, customEventData);
    }
    if (
      KAMPYLE_FUNC.checkProvision(
        KAMPYLE_CONSTANT.PROVISIONS.ENABLE_EVENTS_FOR_CE_DEBUG
      )
    ) {
      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":true}.isDigitalAnalyticsEnabled) {
        MDIGITAL_ANALYTICS.triggerDigitalEvent(
          KAMPYLE_CONSTANT.EVENTS.CUSTOM_EVENTS_DEBUG_MESSAGE,
          {
            customEventId: customEventId,
            customEventData: customEventData,
          }
        );
      }
    }
  }
}

function getCustomEventDataToSend(eventDispatcherDataFormatted) {
  //Specific data for particular custom events
  var dataToSend = {};
  if (!eventDispatcherDataFormatted || !eventDispatcherDataFormatted.payload) {
    return null;
  }

  for (var i = 0; i < eventDispatcherDataFormatted.payload.length; i++) {
    var payloadProperty = eventDispatcherDataFormatted.payload[i];
    var payloadValue = KAMPYLE_UTILS.getNestedPropertyValue(
      eventDispatcherDataFormatted,
      payloadProperty
    );
    var mappingObject;
    if (payloadValue !== undefined && payloadValue !== null) {
      mappingObject = dataToSendMapping[payloadProperty];
      if (mappingObject && mappingObject.exposedProperty) {
        //Use the exposedProperty+Apply method,if exists,that manipulates the value according the expected exposed value.for example: dataToSend[Form_Type] = 'AlwaysOn'
        dataToSend[mappingObject.exposedProperty] = mappingObject.manipulateValueMethod ? mappingObject.manipulateValueMethod.apply(this,[payloadValue]): payloadValue;
      } else {
        //Assign the payloadValue to the payloadProperty as is.for example: dataToSend[formTriggerType] = 'Button'
        dataToSend[payloadProperty] = payloadValue;
      }
    }
  }
  return dataToSend;
}

function manipulateTriggerTypeValue(formTriggerType) {
  return (
    KAMPYLE_CONSTANT.FORM_TRIGGER_TYPES_MAP[formTriggerType] ||
    KAMPYLE_CONSTANT.CUSTOM_EVENT_OTHER
  );
}

function isExposeFormLanguageAllowed() {
  return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXPOSE_SELECTION_QUESTIONS) || KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXPOSE_VERBATIM_QUESTIONS);
}

// TODO: HF for DXA, it will be removed with a followup ticket: NM-17338
function triggerCustomCallback(customEventName, customEventData) {
  function dxa_ready() {
    // eslint-disable-next-line no-undef
    window.dxa_digital_integration && dxa_digital_integration(customEventName, customEventData);
  }
  if (typeof window.decibelInsight === 'function') {
    window.decibelInsight('ready', dxa_ready);
  } else {
    window._da_readyArray = window._da_readyArray || [];
    window._da_readyArray.push(dxa_ready);
  }
}

export default {
  init: init,
  triggerCustomEvent: triggerCustomEvent,
  getCustomEventDataToSend: getCustomEventDataToSend,
  isExposeFormLanguageAllowed: isExposeFormLanguageAllowed,
};
